import { FORM_SUBMIT } from "./const";

const action = (value, formNode) => {
  return {
    type: FORM_SUBMIT,
    value,
    formNode,
  };
};

export default action;
